export default __webpack_public_path__ + "static/AQP_PAConstitution_BusShelter-959a873755ff8c02078c3806d877eaec.pdf";